import { Injectable } from '@angular/core';
import { Behavior, StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class OtpUpdatePageState extends StrictBehavior {
  executeBehavior(args: any, ctx: BehaviorContext): Promise<any> {
    const error = ctx.get('error');
    if (error) {
      return;
    }

    const otpLayoutFactory = ctx.getFactoryById(args.otpLayoutId);

    // otpLayoutFactory.otpPageChild.setPageState('verify');
  }
}
